import React, { Component } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class App extends Component {
  state = {
    chartData: [],
  };

  // Function to fetch data from API
 fetchData = async () => {
  try {
    // Get token from localStorage
    const token = localStorage.getItem('token'); // or 'token', 'accessToken', etc.
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/locations`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, // Add token to Authorization header
      },
    });

    // Check if response is ok
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data && data.bonuses) {
      this.processData(data.bonuses);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
};

  // Function to process the data and prepare it for the chart
  processData = (bonuses) => {
    const countryCount = {};

    // Count the occurrences of each country
    bonuses.forEach(bonus => {
      const country = bonus.country;
      if (countryCount[country]) {
        countryCount[country] += 1;
      } else {
        countryCount[country] = 1;
      }
    });

    // Convert the countryCount object into an array of { country, count }
    const countryArray = Object.keys(countryCount).map(country => ({
      country,
      count: countryCount[country],
    }));

    // Sort the countries by count in descending order
    countryArray.sort((a, b) => b.count - a.count);

    // Limit the data to the top 20 countries
    const topCountries = countryArray.slice(0, 20);

    // Calculate percentage for each country
    const totalLocations = bonuses.length;
    const chartData = topCountries.map(countryObj => {
      const count = countryObj.count;
      const percentage = ((count / totalLocations) * 100).toFixed(2);
      return {
        label: `${countryObj.country} (${percentage}%)`,
        y: count,
      };
    });

    // Set the chart data
    this.setState({ chartData });
  };

  // Fetch data when component mounts
  componentDidMount() {
    this.fetchData();
  }

  render() {
    const options = {
      title: {
        text: "Top 20 Countries",
        fontColor: "#FFF",
      },
      backgroundColor: "transparent",
      axisX: {
        labelFontColor: "#B0B0B0",
        gridColor: "#444",
      },
      axisY: {
        labelFontColor: "#B0B0B0",
        gridColor: "#444",
      },
      data: [
        {
          type: "column",
          dataPoints: this.state.chartData,
          color: "#808080",
        },
      ],
      toolTip: {
        backgroundColor: "#444",
        fontColor: "#FFF",
      },
      legend: {
        fontColor: "#B0B0B0",
      },
      borderColor: "#444",
      borderThickness: 1,
    };

    return (
      <div style={{ padding: "20px" }}>
        <CanvasJSChart options={options} />
      </div>
    );
  }
}

export default App;
